import { getSortedFormFields } from '@utils/forms';

export const getComputeOpsManagementSupportFormData = (target, helpWith, product?) => {
  const namespace: string = 'hpe_compute';
  const subject: string = `HPE Compute Ops Mgmt Support Request : ${helpWith} - {formId}`;

  return getSortedFormFields(target, namespace, subject, '', product);
};
